import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  tone?: 'primary' | 'secondary' | 'quiet' | 'danger';
  iconOnly?: boolean;
};

export function TvButton({ children, className = '', tone = 'secondary', iconOnly = false, ...props }: Props) {
  return (
    <button
      type="button"
      data-tv-focusable
      className={`tv-button tv-button--${tone} ${iconOnly ? 'tv-button--icon' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
